import { dayjs } from '@/utils/dayjs';
import { ICellRendererParams } from '@ag-grid-community/core';
import { renderToString } from 'react-dom/server';

interface ExtendedParams extends ICellRendererParams {
  _timezone: string;
}

interface ICellRendererFunc {
  (params: ExtendedParams): HTMLElement | string;
}

// Attempts to parsed an invalid input via DayJS will result in the string "Invalid Date"
const INVALID_DATE = 'Invalid Date';

function internalDateParser(date: string, timezone: string): string | null {
  try {
    return dayjs(date).tz(timezone).format('MMMM D, YYYY hh:mm A');
  } catch {
    return null;
  }
}

export const DateCellRenderer: ICellRendererFunc = (params) => {
  const date = internalDateParser(params.value, params['_timezone']);

  if (date === INVALID_DATE || Object.is(date, null))
    return renderToString(<div />);

  return renderToString(
    <div data-testid="date-cell-renderer-cell">{date}</div>
  );
};
